import { allPublicationItems } from '../data/newsPublications';

const BASE = 'https://antologia.tech';

export const NEWS_HUB_PATH = '/novosti-antologia';

export const NEWS_CATEGORIES = [
  {
    id: 'all',
    slug: '',
    label: 'Все материалы',
    h1: 'Новости Антологии',
    seoTitle: 'Новости, акции и блог',
    seoDescription:
      'Новости компании Антология, акции и скидки на IT и AI-решения, новости вендоров, статьи блога, анонсы и записи вебинаров.',
    intro:
      'Новости компании, акции, материалы вендоров, статьи блога и вебинары — всё в одном разделе.',
    keywords: 'новости антология, it новости, ai новости, блог антология',
  },
  {
    id: 'antologia',
    slug: 'novosti-antologii',
    label: 'Новости антологии',
    h1: 'Новости Антологии',
    seoTitle: 'Новости компании Антология — партнёрства и мероприятия',
    seoDescription:
      'Официальные новости Антологии: партнёрства с вендорами, участие в форумах и развитие портфеля IT и AI-решений для бизнеса.',
    intro:
      'Анонсы компании: партнёрства, мероприятия и ключевые события в развитии портфеля решений.',
    keywords: 'новости антология, партнёрство just ai, uis, мероприятия',
  },
  {
    id: 'promotions',
    slug: 'akcii-i-skidki',
    label: 'Акции и скидки',
    h1: 'Акции и скидки',
    seoTitle: 'Акции и скидки на IT и AI-решения | Антология',
    seoDescription:
      'Специальные предложения и скидки на лицензии ПО и AI-решения для юридических лиц. Актуальные акции Антологии и вендоров.',
    intro:
      'Выгодные условия на лицензии и сервисы: специальные предложения для малого, среднего и крупного бизнеса.',
    keywords: 'акции it, скидки на по, ai акции, спецпредложения антология',
  },
  {
    id: 'vendor',
    slug: 'novosti-vendorov',
    label: 'Новости вендоров',
    h1: 'Новости вендоров',
    seoTitle: 'Новости вендоров IT и AI | Антология',
    seoDescription:
      'Релизы, обновления и анонсы партнёрских вендоров: Just AI, UIS и другие поставщики решений из каталога Антологии.',
    intro:
      'Свежие материалы от вендоров из нашего каталога: релизы продуктов, обновления и анонсы.',
    keywords: 'новости вендоров, just ai новости, uis новости, релизы по',
  },
  {
    id: 'blog',
    slug: 'blog',
    label: 'Статьи',
    h1: 'Блог',
    seoTitle: 'Блог об AI и IT для бизнеса | Антология',
    seoDescription:
      'Экспертные статьи об искусственном интеллекте, автоматизации и внедрении IT-решений для российских компаний.',
    intro:
      'Статьи об AI, автоматизации бизнес-процессов и практическом внедрении технологий.',
    keywords: 'блог ai, статьи об искусственном интеллекте, it для бизнеса',
  },
  {
    id: 'webinars',
    slug: 'vebinary',
    label: 'Вебинары',
    h1: 'Вебинары',
    seoTitle: 'Вебинары по AI и IT для бизнеса | Антология',
    seoDescription:
      'Анонсы предстоящих вебинаров Антологии и партнёров: внедрение AI, лицензирование ПО и практические кейсы.',
    intro: 'Расписание предстоящих онлайн-мероприятий с экспертами и вендорами.',
    keywords: 'вебинары ai, it вебинары, онлайн мероприятия антология',
  },
  {
    id: 'webinar-recordings',
    slug: 'zapisi-vebinarov',
    label: 'Записи вебинаров',
    h1: 'Записи вебинаров',
    seoTitle: 'Записи вебинаров по AI и IT | Антология',
    seoDescription:
      'Архив записей вебинаров: разбор кейсов внедрения AI, обзоры решений и ответы на вопросы бизнеса.',
    intro: 'Записи прошедших вебинаров — смотрите в удобное время.',
    keywords: 'записи вебинаров, архив вебинаров ai, видео it',
  },
];

const CATEGORY_BY_ID = new Map(NEWS_CATEGORIES.map((c) => [c.id, c]));
const CATEGORY_BY_SLUG = new Map(
  NEWS_CATEGORIES.filter((c) => c.slug).map((c) => [c.slug, c]),
);
const CATEGORY_IDS = new Set(NEWS_CATEGORIES.map((c) => c.id));

export function getCategoryMeta(categoryId = 'all') {
  return CATEGORY_BY_ID.get(categoryId) || CATEGORY_BY_ID.get('all');
}

export function getCategoryBySlug(slug) {
  if (!slug) return CATEGORY_BY_ID.get('all');
  return CATEGORY_BY_SLUG.get(slug) || null;
}

export function parseCategorySlug(slug) {
  const category = getCategoryBySlug(slug);
  return category?.id || null;
}

/** @deprecated Используйте parseCategorySlug; сохранено для редиректа ?filter= */
export function parseNewsFilter(raw) {
  if (!raw || raw === 'all') return 'all';
  return CATEGORY_IDS.has(raw) ? raw : 'all';
}

export function buildNewsHubPath(categoryId = 'all') {
  const category = getCategoryMeta(categoryId);
  if (!category.slug) return NEWS_HUB_PATH;
  return `${NEWS_HUB_PATH}/${category.slug}`;
}

export function getNewsHubCanonical(categoryId = 'all') {
  return `${BASE}${buildNewsHubPath(categoryId)}`;
}

export function getNewsHubSeo(categoryId = 'all') {
  const category = getCategoryMeta(categoryId);
  return {
    title: `${category.seoTitle} | Антология`,
    description: category.seoDescription,
    keywords: category.keywords,
    canonical: getNewsHubCanonical(categoryId),
    h1: category.h1,
    intro: category.intro,
  };
}

export const NEWS_HUB_ROUTES = NEWS_CATEGORIES.map((c) => buildNewsHubPath(c.id));

export function getStaticPublications() {
  return [...allPublicationItems].sort(
    (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt),
  );
}

export function getAllPublications() {
  return getStaticPublications();
}

export function filterPublications(items, categoryId = 'all') {
  const category = parseNewsFilter(categoryId);
  if (category === 'all') return items;
  return items.filter((item) => item.category === category);
}

/** Ключ для дедупликации: slug, href блога или id. */
export function publicationDedupeKey(item) {
  if (item.slug) return `slug:${item.slug}`;
  if (item.href?.startsWith('/blog/')) return `blog:${item.href}`;
  return `id:${item.id}`;
}

function sortByPublishedAt(items) {
  return [...items].sort(
    (a, b) => new Date(b.publishedAt || 0) - new Date(a.publishedAt || 0),
  );
}

/** Объединяет статику и API; при совпадении ключа приоритет у записи из API. */
export function mergePublications(staticItems = [], apiItems = []) {
  const map = new Map();

  staticItems.forEach((item) => {
    map.set(publicationDedupeKey(item), { ...item, source: item.source || 'static' });
  });

  apiItems.forEach((item) => {
    map.set(publicationDedupeKey(item), { ...item, source: item.source || 'api' });
  });

  return sortByPublishedAt(Array.from(map.values()));
}

export function getPublicationHref(item) {
  if (item.href) return item.href;
  return null;
}

export function buildNewsHubStructuredData(categoryId, items) {
  const category = getCategoryMeta(categoryId);
  const pagePath = buildNewsHubPath(categoryId);
  const pageUrl = `${BASE}${pagePath}`;

  const breadcrumbs = [
    { name: 'Главная', item: `${BASE}/` },
    { name: 'Новости', item: `${BASE}${NEWS_HUB_PATH}` },
  ];
  if (categoryId !== 'all') {
    breadcrumbs.push({ name: category.label, item: pageUrl });
  }

  const listItems = items.slice(0, 30).map((item, index) => {
    const itemUrl = item.href ? `${BASE}${item.href}` : pageUrl;
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: item.title,
      url: itemUrl,
    };
  });

  return [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.map((crumb, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.name,
        item: crumb.item,
      })),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: category.h1,
      description: category.seoDescription,
      url: pageUrl,
      inLanguage: 'ru-RU',
      isPartOf: {
        '@type': 'WebSite',
        name: 'Антология',
        url: BASE,
      },
      mainEntity: {
        '@type': 'ItemList',
        numberOfItems: items.length,
        itemListElement: listItems,
      },
    },
  ];
}
